export function dashCase(str) {
    return typeof str === "string"
        ? str.split(/([_A-Z])/).reduce((one, two, idx) => {
            const dash = !one || idx % 2 === 0 ? "" : "-";
            two = two === "_" ? "" : two;
            return `${one}${dash}${two.toLowerCase()}`;
        })
        : str;
}
/**
 * Make it so that when ReactDOM is rendering into `node`,
 * it will bind event handlers on it for its synthetic event
 * system instead of binding everything on the `document`.
 *
 * This is necessary to allow the events to work properly whenever
 * we are rendering inside a Shadow DOM (either explicitely or because the
 * application the widget is inserted into has decided so (like SGDashboard
 * v2 does.))
 *
 * This is mostly taken from a comment on React issue tracker:
 * https://github.com/facebook/react/issues/9242#issuecomment-543117675
 *
 * And enriched with additional properties forwarded to make some libraries work
 * right (like popper.js).
 */
export function mimickAsDocument(node) {
    if (node.__sg_widgets_mimick_document__ === undefined) {
        Object.defineProperty(node, "__sg_widgets_mimick_document__", {
            value: true,
        });
        // `ownerDocument` is the thing that ReactDOM uses to find the document.
        // so we give him back the node itself !
        Object.defineProperty(node, "ownerDocument", { value: node });
        // The 3 following methods are necessary to allow ReactDOM to work
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeAsAny = node;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const documentAsAny = document;
        nodeAsAny.createElement = (...args) => {
            return documentAsAny.createElement(...args);
        };
        nodeAsAny.createElementNS = (...args) => {
            return documentAsAny.createElementNS(...args);
        };
        nodeAsAny.createTextNode = (...args) => {
            return documentAsAny.createTextNode(...args);
        };
        // `defaultView` is necessary for popperjs v1.x to work
        // https://github.com/popperjs/popper.js/blob/v1.x/packages/popper/src/utils/getStyleComputedProperty.js#L13
        Object.defineProperty(node, "defaultView", {
            get: function () {
                return document.defaultView;
            },
        });
    }
}
